import React, { useEffect, useState } from 'react';
import Checkbox from './Checkbox';
import { WizardColumnSelectorProps } from '../../types/WizardDateAndColumnSelectorProps';
import Utils from '../../utils/Utils';

function WizardColumnSelector(props: WizardColumnSelectorProps): JSX.Element {
  const {
    selectedColumns,
    setSelectedColumns,
    mode,
    nodeGroup,
    allSelected,
    setAllSelected,
  } = props;

  const columns = [
    'SITE_NAME',
    'ORG_NAME',
    'GROUP_NAMES',
  ];

  const nodeColumns = [
    'NODE_ID',
    'NODE_NAME',
    'FIXTURE',
    'POWER_DRAW',
    'LOCATION',
    'SCHEDULE',
  ];

  const [allPossibleColumns] = useState<string[]>(() => [
    ...((mode === 'AGGREGATED' && (nodeGroup === 'site' || nodeGroup === 'node')) ? columns.filter((e) => !(e === 'GROUP_NAMES')) : columns),
    ...((mode === 'INDIVIDUAL') ? nodeColumns : []),
  ]);

  useEffect(() => {
    setSelectedColumns(selectedColumns.filter((item) => allPossibleColumns.includes(item)));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allPossibleColumns]);

  const columnCheckboxRenderer = (element: string, index: number) => (
    <div key={element} className={!(allPossibleColumns.includes(element)) ? 'columns--disabled' : ''}>
      <Checkbox
        checked={selectedColumns.includes(element)}
        dark={false}
        disabled={!(allPossibleColumns.includes(element))}
        onClick={(checked) => {
          if (checked) {
            setSelectedColumns([...selectedColumns, element]);
          } else {
            setSelectedColumns(
              selectedColumns.filter((id: string) => id !== element),
            );
          }
        }}
      />
      <span>{Utils.getColumnNameString(element)}</span>
    </div>
  );
  return (
    <div className="column-selector">
      <div className="column-selector__instruction">Select report output columns</div>
      <div className="columns columns--all">
        <div>
          <Checkbox
            checked={allSelected}
            dark={false}
            onClick={(checked) => {
              setSelectedColumns(checked ? allPossibleColumns : []);
              setAllSelected(checked);
            }}
          />
          <span>All</span>
        </div>
      </div>
      <div className="columns columns--general">
        {columns.map((element, index) => columnCheckboxRenderer(element, index))}
      </div>
      <div className="columns columns--node">
        {nodeColumns.map((element, index) => columnCheckboxRenderer(element, index))}
      </div>
    </div>
  );
}

export default WizardColumnSelector;
